(function () {
  const SPEED_PX_PER_SEC = 80;
  const MAX_LOOPS = 64;

  function setupTicker(ticker) {
    const track = ticker.querySelector('.site-ticker__track');
    const sourceGroup = track && track.querySelector('.site-ticker__group');
    if (!track || !sourceGroup) return;

    if (!ticker._tickerTemplates) {
      ticker._tickerTemplates = Array.from(
        sourceGroup.querySelectorAll('.site-ticker__item')
      ).map(function (item) {
        return item.cloneNode(true);
      });
    }

    const templates = ticker._tickerTemplates;
    if (!templates.length) return;

    const viewport = ticker.clientWidth;
    const group1 = document.createElement('div');
    group1.className = 'site-ticker__group';

    for (let loop = 0; loop < MAX_LOOPS; loop += 1) {
      templates.forEach(function (template) {
        group1.appendChild(template.cloneNode(true));
      });

      track.replaceChildren(group1);
      if (group1.getBoundingClientRect().width >= viewport) break;
    }

    const groupWidth = group1.getBoundingClientRect().width;
    if (!groupWidth) return;

    const group2 = group1.cloneNode(true);
    group2.setAttribute('aria-hidden', 'true');
    track.replaceChildren(group1, group2);

    track.style.setProperty('--ticker-offset', '-' + groupWidth + 'px');
    track.style.setProperty(
      '--ticker-duration',
      Math.max(groupWidth / SPEED_PX_PER_SEC, 12) + 's'
    );
    ticker.setAttribute('data-ticker-ready', '');
  }

  function init() {
    document.querySelectorAll('[data-site-ticker]').forEach(setupTicker);
  }

  let resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(init);
  }

  window.addEventListener('resize', onResize);
})();
